module.exports = __webpack_public_path__ + "images/cfad01717e2f0414953160dd2462d7e5.svg";